import { useState, useEffect, useMemo } from "react";

import { getActiveSubscription } from "../services/subscriptionHistoryService";

import { getOrganizationId } from "../utils/organizationUtils";

import {
  DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS,
  parseOpdConsultationWaiverSettings,
} from "../utils/opdConsultationWaiverUtils";

export const useOpdConsultationWaiverSettings = (
  user,
  { enabled = true } = {}
) => {
  const [settings, setSettings] = useState({
    ...DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS,
  });

  const [loading, setLoading] = useState(Boolean(enabled));

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchSettings = async () => {
      setLoading(true);

      try {
        const organizationId = getOrganizationId(user);

        if (organizationId) {
          const activeSubscription =
            await getActiveSubscription(organizationId);

          if (!cancelled) {
            setSettings(
              parseOpdConsultationWaiverSettings(
                activeSubscription
              )
            );
          }
        } else if (!cancelled) {
          setSettings({
            ...DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS,
          });
        }
      } catch (error) {
        console.error(
          "Error fetching OPD consultation waiver settings:",
          error
        );

        if (!cancelled) {
          setSettings({
            ...DEFAULT_OPD_CONSULTATION_WAIVER_SETTINGS,
          });
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchSettings();

    return () => {
      cancelled = true;
    };
  }, [user, enabled]);

  return useMemo(
    () => ({
      ...settings,
      loading,
    }),
    [settings.enabled, settings.gapDays, loading]
  );
};

export default useOpdConsultationWaiverSettings;